<script>
  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';

  export let mobile = false;

  let showModal = false;

  function openModal() {
    showModal = true;
  }

  function closeModal() {
    showModal = false;
  }
</script>

<style lang="scss">
  .creator-scout-badge {
    display: inline-flex;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 32px;
    border: 1px solid #ececec;
    background: #f1f1f1;
    cursor: pointer;

    &:hover {
      background: #e0e0e0;
    }

    .creator-scout-badge-text {
      color: #1a1a1a;
      text-align: center;
      /* Product/Headline/Headline 6 */
      font-family: 'Helvetica Neue';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 142.857% */
    }
  }

  .creator-scout-modal {
    .creator-scout-modal-header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      flex-direction: column;
      margin-bottom: 52px;

      .creator-scout-modal-header-image {
        width: 120px;
        height: 120px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f3fc;
        margin-bottom: 20px;
      }

      .creator-scout-modal-header-text-title {
        color: #000;
        text-align: center;
        font-family: 'Helvetica Neue';
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px;
      }

      .creator-scout-modal-header-text-subtitle {
        color: #797979;
        text-align: center;
        font-family: 'Helvetica Neue';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }
    }

    .creator-scout-modal-body {
      color: #707070;
      font-family: 'Helvetica Neue';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      max-width: 576px;
      margin-left: auto;
      margin-right: auto;

      div {
        a {
          color: #7054dc;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .creator-scout-modal-footer {
      width: 180px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 80px;
    }
  }
</style>

<div class="creator-scout-badge" on:click={openModal}>
  <img src="/images/creator-scout/star.png" style="width: 16px; height: 16px;" alt="Creator Scout" />
  <span class="creator-scout-badge-text">Creator Scout</span>
</div>

<div class="svelte-modal">
  <Modal bind:show={showModal} style="width: 100%; max-width: 780px;" showCloseButton={false} mobile={mobile}>
    <div slot="content">
      <div class="creator-scout-modal">
        <div class="creator-scout-modal-header">
          <div class="creator-scout-modal-header-image">
            <img
              src="/images/creator-scout/star.png"
              srcset="/images/creator-scout/star.png 1x, /images/creator-scout/star@2x.png 2x"
              alt="Creator Scout" />
          </div>
          <span class="creator-scout-modal-header-text-title">Benable Creator Scouts</span>
          <span class="creator-scout-modal-header-text-subtitle">A distinction for top Benable members</span>
        </div>
        <div class="creator-scout-modal-body">
          <div>
            The Benable Creator Scout badge is a distinction for trusted members of the Benable community. Scouts are
            able to nominate creators across platforms to join Benable’s invite only creator program. Scouts earn
            rewards for finding people who make great recommendations, and nominating them to join Benable.
          </div>
          <div>
            Interested in becoming a scout? Email <a href="mailto:scouts@benable.com">scouts@benable.com</a> to be considered!
          </div>
        </div>
        <div class="creator-scout-modal-footer">
          <Button text="Close" on:click={closeModal} />
        </div>
      </div>
    </div>
  </Modal>
</div>
